module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_33.3ece1fe6.jpg";